export default [
  {
    path: '/application/cmmonUserApply',
    name: 'cmmonUserApplyfor',
    component: () => import('@/views/application/index.vue'),
    meta: {
      title: '申请调解',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  {
    path: '/caseDetail',
    name: 'userCaseDetail',
    component: () => import('@/views/application/userCaseDetail.vue'),
    meta: {
      title: '案件详情',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
  },
];
